import AdminConfigurator from '../../../pages/mpacConfigurator/AdminConfigurator';

const AddonAdminPageRouteProcessor = () => {
  return <AdminConfigurator />;
};

export default AddonAdminPageRouteProcessor;
